import { giphyLightGrey } from '@giphy/colors'
import { ReactNode } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import { Subtitle } from '../../typography'
import Icon from './field-icon'

const Title = styled(Subtitle)`
    color: ${giphyLightGrey};
    margin-bottom: 0;
`

type Props = {
    children?: ReactNode
    className?: string
    field: CreationToolUploadField
}

const CreationUploadFieldTitle = ({ children, className, field }: Props) => {
    const title = CreationToolUploadField.title(field)
    return (
        <Title className={className}>
            <Icon field={field} />
            {title}
            {children}
        </Title>
    )
}

export default CreationUploadFieldTitle
